export const HUB_HEADER_COMPACT_EVENT = "hub-header-compact" as const;

export function dispatchHubHeaderCompact(visible: boolean) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(HUB_HEADER_COMPACT_EVENT, { detail: { visible } }));
}
